import { BaseModel } from './base.model';

export default class Comune extends BaseModel  {
  id: number = null;
  citta: string = null;
  provincia: string = null;
  codice: string = null;
  cap: string = null;
  deletedAt: string|null = null;
  createdAt: string|null = null;
  updatedAt: string|null = null;
}


